import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';

const VERIFICATION = {
    unverified: { label: 'Unverified', color: 'default', variant: 'outlined', tip: 'Not yet checked against manufacturer documentation' },
    committee_reviewed: { label: 'Committee reviewed', color: 'primary', variant: 'outlined', tip: 'Reviewed by the committee' },
    manufacturer_verified: { label: 'Manufacturer verified', color: 'success', variant: 'filled', tip: 'Confirmed by the manufacturer' }
};

const VerificationChip = ({ verification = 'unverified', size = 'small' }) => {
    const v = VERIFICATION[verification] || VERIFICATION.unverified;
    return (
        <Tooltip title={v.tip}>
            <Chip
                size={size}
                label={v.label}
                color={v.color}
                variant={v.variant}
                icon={verification === 'unverified' ? undefined : <VerifiedIcon />}
            />
        </Tooltip>
    );
};

export default VerificationChip;
